<template>
  <v-layout>
    <v-flex xs12>

      <calendar
        ref="calendar"
        v-model="selectedMonth"
        :avvisi="avvisi"
        :loading="loading"
        @update-view="onCalendarUpdated"
        @click:add="onAddClick"
        @click:edit="onEditClick"
        @click:delete="onDeleteClick"/>

      <avviso-menu
        ref="avvisoMenu"
        @success="onCalendarUpdated(null, null)"
        @click:delete="onDeleteClick"/>

      <!-- <onboarding-dialog ref="onboardingDialog"/> -->

    </v-flex>
  </v-layout>
</template>

<script>
import Calendar from '@/components/calendar/Calendar'
import OnboardingDialog from '@/components/OnboardingDialog'
import AvvisoMenu from '@/components/AvvisoMenu'

export default {
    name: 'Avvisi',
    components: { AvvisoMenu, Calendar, OnboardingDialog },
    data () {
        return {
            loading: true,
            fromDate: null,
            toDate: null,
            avvisi: [],
            selectedMonth: this.$utils.date.getSqlCurrentMonth()
        }
    },
    mounted () {
        // if (this.$store.state.settings.showOnboarding) {
        //     this.$refs.onboardingDialog.show()
        //     this.$store.commit('SET_SHOW_ONBOARDING', false)
        // }
    },
    methods: {
        onAddClick (activatorId, date) {
            this.$refs.avvisoMenu.showCreate(activatorId, { data_avviso: this.$utils.date.toSql(date) })
        },
        onEditClick (avviso) {
            this.$refs.avvisoMenu.showEdit('a' + avviso.id, avviso)
        },
        onDeleteClick (id) {
            this.$confirmDialog.show(id, this.$t('messaggi.conferma_eliminazione'), this.deleteAvviso)
        },
        onCalendarUpdated (fromDate, toDate) {
            this.fromDate = fromDate || this.fromDate
            this.toDate = toDate || this.toDate
            this.closeMenus()
            this.fetchAvvisi()
        },
        deleteAvviso (id) {
            this.$api.avvisi.delete(id).then(response => {
                this.$snackbar.show(this.$t('avvisi.messaggi.eliminato'), 'success')
                this.onCalendarUpdated(null, null)
            }).catch(e => {
                this.$snackbar.showServerError(e)
            })
        },
        fetchAvvisi () {
            this.loading = true
            this.$api.avvisi.get(this.fromDate, this.toDate).then(response => {
                this.loading = false
                this.avvisi = response.data || []
            }).catch(e => {
                this.loading = false
                this.$snackbar.showServerError(e)
            })
        },
        closeMenus () {
            this.$refs.calendar && this.$refs.calendar.closeMenus()
            this.$refs.avvisoMenu && this.$refs.avvisoMenu.close()
        }
    }
}
</script>
